/*
 * @Description:批量操作运单
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-01-04 15:44:23
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import { batchPageList } from '@/api/waybill';
import { pay } from '@/utils/dictionary/waybillselect';

const state = {
  // 接口调用参数
  postParams: {
    page: 1,
    size: 20,
    // vehicleNo: '',
    // payeeName: '',
    // driverName: '',
    // waybillNo: '',
  },
  operation: '',
  businessId: '',
  params: { type: 'waybillNo', value: '' },
  // {waybillNo:'1'}
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [],
    total: 0,
  },
  headList: [
    {
      label: '运单',
      prop: 'waybillNo',
      width: 220,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-waybillNo',
      allow: ['deleteList', 'oil', 'prepaid', 'receive', 'back', 'freight', 'downloadPicture'],
    },
    {
      label: '运单状态',
      prop: 'waybillStatus',
      width: 80,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-waybillStatus',
      allow: ['deleteList', 'oil', 'prepaid', 'receive', 'back', 'freight', 'downloadPicture'],
    },
    {
      label: '装卸货时间',
      prop: 'startTime',
      width: 180,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-startTime',
      allow: ['deleteList', 'oil', 'prepaid', 'receive', 'back', 'freight', 'downloadPicture'],
    },
    {
      label: '司机车辆',
      prop: 'driverName',
      width: 80,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-driverName',
      allow: ['deleteList', 'oil', 'prepaid', 'receive', 'back', 'freight', 'downloadPicture'],
    },
    {
      label: '运费',
      prop: 'freight',
      width: 100,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-freight',
      allow: ['deleteList'],
    },
    {
      label: '支付类型',
      prop: 'operation',
      width: 100,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-operation',
      allow: ['oil', 'prepaid', 'receive', 'back'],
    },
    {
      label: '支付渠道',
      prop: 'channelInfoName',
      width: 140,
      checked: 1,
      sortable: true,
      //   slotName: 'sub-domain-driverName',
      allow: ['oil', 'prepaid', 'receive', 'back'],
    },
    {
      label: '支付方式',
      prop: 'payType',
      width: 80,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-payType',
      allow: ['oil', 'prepaid', 'receive', 'back'],
    },
    {
      label: '支付金额',
      prop: 'payfreight',
      width: 100,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-payfreight',
      allow: ['oil', 'prepaid', 'receive', 'back'],
    },
    {
      label: '操作',
      prop: '',
      width: 100,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-status',
      allow: ['deleteList', 'oil', 'prepaid', 'receive', 'back', 'downloadPicture'],
    },
  ],
};

// getters
const getters = {};

// actions
const actions = {
  getList: async context => {
    const val = {};
    val[context.state.params.type] = context.state.params.value;
    const obj = Object.assign({}, val, context.state.postParams, JSON.parse(localStorage.batch));
    const headerlist = context.state.headList.filter(item => {
      return item.allow.includes(JSON.parse(localStorage.batch).operation);
    });
    context.commit('updateEditTableList', headerlist);
    const { data } = await batchPageList(obj);
    context.commit('updateListData', Object.assign({}, context.state.listData, data));
    return data.list;
  },
};

// mutations
const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = payload;
  },
  // 更新列表表头数据

  updateEditTableList(state, payload) {
    state.listData.tableHeadList = payload;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  upOperation(state, payload) {
    state.operation = payload;
  },
  upParams(state, payload) {
    state.params = payload;
  },
  upmyselfWaybill(state, payload) {
    state.postParams.myselfWaybill = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
